import { Component, OnInit } from '@angular/core';
import { appVersion } from '../../../../src/version';
import gitInfo from '../../../../src/git-version.json';

@Component({
  selector: 'ect-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'customer-tracking';

  ngOnInit() {
    console.table({
      Version: appVersion,
      Hash: gitInfo.hash,
      BuildTime: gitInfo.time,
    });
  }
}
